module.exports = __webpack_public_path__ + "static/media/group-share-guide.1b249589.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/groupBuy/group-share-guide.png
// module id = 1914
// module chunks = 6